import { writable } from 'svelte/store';

export const webSocketMessages = writable({
	status: 'Closed',
	messages: []
});
